import { darkTheme as iDarkTheme, theme as iLightTheme } from '@intelie/ui'
import React, { useContext, createContext } from 'react'
import { ThemeProvider, useTheme } from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'
import liveTheme from 'live/services/theme'

import { ILivePageProps, IQueryParamsAssetTypeList, IResourceTypeRouteContext } from '../types'
import { defaultParamsForResourceType } from '../utils/constants'
import { AssetTypeConfiguration } from './'

const lightTheme = { ...iLightTheme, ...liveTheme }
const darkTheme = { ...iDarkTheme, ...liveTheme }

function toQueryString(obj: IQueryParamsAssetTypeList): string {
    return Object.keys(obj)
        .filter(key => typeof obj[key] === 'string' || typeof obj[key] === 'number' || typeof obj[key] === 'boolean')
        .map(key => (obj[key] !== undefined && obj[key] !== null ? `${key}=${obj[key]}` : undefined))
        .filter(e => e)
        .join('&')
}

export function setParams(params: IQueryParamsAssetTypeList): void {
    window.location.href = `/#/config/resource_manager_type?${toQueryString(params)}`
}

export const ResourceTypeConfigurationRouteContext = createContext({
    params: defaultParamsForResourceType,
    setParams
} as IResourceTypeRouteContext<IQueryParamsAssetTypeList>)

export const AssetsTypeConfigurationWrapper: React.FC<ILivePageProps> = ({ id: params }) => {
    const theme = useTheme()
    const dashTheme = useContext(DashboardContext).theme

    if (theme?.['gray-100']) {
        return (
            <ResourceTypeConfigurationRouteContext.Provider
                value={{ params: (params as IQueryParamsAssetTypeList) ?? defaultParamsForResourceType, setParams }}
            >
                <AssetTypeConfiguration />
            </ResourceTypeConfigurationRouteContext.Provider>
        )
    } else {
        return (
            <ThemeProvider theme={dashTheme === 'light' ? lightTheme : darkTheme}>
                <ResourceTypeConfigurationRouteContext.Provider
                    value={{ params: (params as IQueryParamsAssetTypeList) ?? defaultParamsForResourceType, setParams }}
                >
                    <AssetTypeConfiguration />
                </ResourceTypeConfigurationRouteContext.Provider>
            </ThemeProvider>
        )
    }
}
